import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { DeleteEcshopAccountsService } from "@/features/accounts/ecshop/services/delete-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";


export const useDeleteEcshopAccounts = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const deleteEcshopAccountsService = new DeleteEcshopAccountsService();

  // 金融機関削除
  const deleteEcshopAccounts = async (
    accountGroupId: string,
    ecshopAccountId: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await deleteEcshopAccountsService.deleteEcshopAccounts({
        account_group_id: accountGroupId,
        ecshop_account_id: ecshopAccountId,
      });
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("deleteEcshopAccounts:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    deleteEcshopAccounts: errorHandledAsync(deleteEcshopAccounts, setError),
  };
};
